import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import { CommonAction } from '@stores/common/action';
import type { ProductAction } from '@stores/product/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';


interface ProductListProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    product?: ProductAction;
    common?: CommonAction;
}

interface ProductListState {
    loading: boolean;
    error: any
    pageLoaded: any
    productList: any
    navList: any
    navCurrentIndex: any
    navCurrentType: any
    ruleValue: any
}
@inject('app', 'product', 'common')
@observer
class ProductList extends BasePage<ProductListProps, ProductListState> {
    namespace='productList';
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        productList: [],   // 新品列表
        navList: [
            {name: '试用', id: 0, type: '0'},
            {name: '我的', id: 1, type: '1'},
        ],
        navCurrentIndex: 0, // 导航当前选中索引
        navCurrentType: '',
        ruleValue: '',  // 规则
    };
    componentDidMount() {
        document.title = '新品体验官招募';
        // 初始化获取列表
        this.getProductList();
        this.getSettingsData();
       super.componentDidMount();
    }

    componentWillUnmount() {
        document.title = '';
    }

    // 获取规则
    getSettingsData = async() => {
        const { common } = this.props;
        console.log('获取规则', common);
        if(common) {
            let params:any = {
                key: 'trial_product_rule',
                tag: 'default',
            }
            const res = await common.getSettings(params);
            this.setState({
                ruleValue: res.data.value
            })
        }
    }
    
    // 加载试用产品列表
    getProductList = () => {
        // console.log('调用接口');
        const { product } = this.props;
        let { navCurrentType } = this.state;
        if(product) {
            // 如果是type为1，调用我的试用列表接口
            if (navCurrentType === '1') {
                let params:any = {
                    "page[number]": 1,
                    "page[size]": 10,
                }
                product.getProductMyList(params)
            } else {
                let params:any = {
                    "page[number]": 1,
                    "page[size]": 10,
                }
                
                if(navCurrentType) {
                    params['filter[status]'] = navCurrentType
                }
                product.getProductList(params);
                
            }
        }
    }

    // 只获取数据，不渲染
    getProductListData = () => {
        const { product } = this.props;
        const { navCurrentType } = this.state;
        if (!product || !product.listStore) return [];
        
        // 根据当前选中的标签类型决定使用哪个namespace
        const namespace = navCurrentType === '1' ? 'productMyList' : this.namespace;
        const list = product.listStore.lists[namespace];
        if (!list) return [];
        return product.listStore.getList({ namespace });
    }

    // 类型切换
    navClick = (item:any, index:any) => {
        this.setState({
            navCurrentIndex: index,
            navCurrentType: item.type
        }, () => {
            this.getProductList();
        })
    }

    // 分页 - 加载更多
    handleLoadMore = () => {
        console.log('handleLoadMore');
        const { product } = this.props;
        const { navCurrentType } = this.state;
        
        if (!product) return;

        // 根据当前选中的标签类型决定使用哪个namespace
        const namespace = navCurrentType === '1' ? 'productMyList' : this.namespace;
        const list = product.listStore.lists[namespace];
        
        if (!list) return;

        // 判断是否还有更多数据
        if (!list.hasMore) {
            return;
        }

        // 防止重复加载
        if (list.loading) {
            return;
        }

        // 获取当前页码
        const currentPage = list.attribs?.page || 1;
        const nextPage = currentPage + 1;

        // 加载更多数据
        const params:any = {
            "page[number]": nextPage,
            "page[size]": 10,
        }
        
        if (navCurrentType) {
            params['filter[status]'] = navCurrentType
        }
        
        // 根据当前选中的标签类型决定调用哪个接口
        if (navCurrentType === '1') {
            product.getProductMyList(params);
        } else {
            product.getProductList(params);
        }
    }

    render() {
        const { app, product } = this.props;
        const { navList, navCurrentIndex, ruleValue } = this.state;
        const platform = app?.platform || 'h5';
         // 获取列表数据和状态
        const namespace = this.state.navCurrentType === '1' ? 'productMyList' : this.namespace;
        const listStore = product?.listStore;
        const list = listStore?.lists[namespace];
        const productList = listStore?.getList({ namespace }) || [];
        const loading = list?.loading || false;
        const hasMore = list?.hasMore ?? true;
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
           return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                    {...this.props}
                    productList={productList}
                    navList={navList}
                    navCurrentIndex={navCurrentIndex}
                    navClick={this.navClick}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={this.handleLoadMore}
                ></PC>) : (
                    <H5
                        {...this.props}
                        productList={productList}
                        ruleValue={ruleValue}
                        navList={navList}
                        navClick={this.navClick}
                        navCurrentIndex={navCurrentIndex}
                        loading={loading}
                        hasMore={hasMore}
                        onLoadMore={this.handleLoadMore}
                    ></H5>
                )}
            </div>)
        }
        
    }
}

export default withRouter(ProductList);